













































































import { Vue, Component, Prop } from "vue-property-decorator";
import StatusBadge from "@/components/Quotation/StatusBadge.vue";

@Component({
  components: {
    StatusBadge,
  },
})
export default class Badges extends Vue {}
